import { gql } from '@apollo/client';
import { apolloClient } from '../../../ApolloClient';
import { QueryTriggerWorkflowWithTestEventArgs, TestWorkflowInput, TriggerWorkflowDto } from '@stigg-types/apiTypes';
import { useMutation } from '@tanstack/react-query';
import { executeOperationSafely } from '@stigg-common';
import { useDispatch } from 'react-redux';

const TEST_WORKFLOW_EVENT = gql`
  query TriggerWorkflowWithTestEvent($input: TestWorkflowInput!) {
    triggerWorkflowWithTestEvent(input: $input) {
      response
      success
    }
  }
`;

export const useSendTestWorkflowTriggerEvent = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (input: TestWorkflowInput) =>
      executeOperationSafely(
        () =>
          apolloClient.query<TriggerWorkflowDto, QueryTriggerWorkflowWithTestEventArgs>({
            query: TEST_WORKFLOW_EVENT,
            fetchPolicy: 'network-only',
            variables: {
              input,
            },
          }),
        {},
        dispatch,
      ),
  });
};
